import styled from 'styled-components';
import CoreStyledButton from 'gatsby-theme-core/src/components/button/styled-button';

export default styled(CoreStyledButton)`
  border-radius: .25rem;
`;
